/**
 * Utility for merging Tailwind class names conditionally.
 * Usage: cn('base-class', condition && 'conditional-class', 'another-class')
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
